// packages/shared/api-client/endpoints/auditLogs.js
// Audit log viewing and filtering API endpoints

import { baseApi } from "../baseApi";

/**
 * Audit Log API endpoints
 * Provides audit log viewing, filtering, and metadata
 */
const auditLogApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get audit logs with filtering
    getAuditLogs: builder.query({
      query: (params = {}) => ({
        url: "/api/audit-logs",
        params, // { userId?, action?, resourceType?, startDate?, endDate?, page?, limit? }
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.logs.map(({ id }) => ({ type: "AuditLog", id })),
              { type: "AuditLog", id: "LIST" },
            ]
          : [{ type: "AuditLog", id: "LIST" }],
    }),

    // Get available action types for filtering
    getAuditLogActions: builder.query({
      query: () => "/api/audit-logs/actions",
      providesTags: ["AuditLog"],
    }),

    // Get available resource types for filtering
    getAuditLogResourceTypes: builder.query({
      query: () => "/api/audit-logs/resource-types",
      providesTags: ["AuditLog"],
    }),
  }),
});

// Export hooks for usage in components
export const useGetAuditLogsQuery = auditLogApi.useGetAuditLogsQuery;
export const useGetAuditLogActionsQuery =
  auditLogApi.useGetAuditLogActionsQuery;
export const useGetAuditLogResourceTypesQuery =
  auditLogApi.useGetAuditLogResourceTypesQuery;
